import React from 'react';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
export function OfferSection() {
  return <section id="offer-section" className="py-20 md:py-32 px-4 bg-burgundy text-cream relative" data-id="element-86">
      <div className="absolute top-0 left-0 w-full h-4 bg-gold" data-id="element-87"></div>

      <div className="max-w-4xl mx-auto" data-id="element-88">
        <div className="bg-white text-charcoal p-8 md:p-16 rounded-sm shadow-2xl border-4 border-gold text-center relative" data-id="element-89">
          {/* Decorative badge */}
          <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-gold text-burgundy font-bold px-6 py-2 rounded-full shadow-md flex items-center gap-2" data-id="element-90">
            <ShieldCheck className="w-5 h-5" data-id="element-91" />
            <span data-id="element-92">Oferta Especial</span>
          </div>

          <h2 className="text-3xl md:text-5xl font-bold text-burgundy mb-6 mt-4" data-id="element-93">
            Obtenga el sistema completo <br className="hidden md:block" data-id="element-94" />
            <span className="text-gold" data-id="element-95">Legado Digital Seguro</span> hoy mismo.
          </h2>

          <p className="text-xl md:text-2xl mb-8 leading-relaxed" data-id="element-96">
            No es solo un libro; es el último gran regalo de orden y protección
            para los que más ama. Invierte hoy en la tranquilidad de su familia.
          </p>

          <div className="my-10 py-8 border-y-2 border-cream-dark" data-id="element-97">
            <p className="text-lg text-charcoal-light uppercase tracking-widest mb-2 font-semibold" data-id="element-98">
              Precio Especial
            </p>
            <p className="text-3xl text-charcoal-light font-heading line-through opacity-60 mb-1" data-id="element-99">
              $19.99 USD
            </p>
            <p className="text-6xl md:text-7xl font-heading font-bold text-burgundy" data-id="element-100">
              $6.39{' '}
              <span className="text-3xl text-charcoal-light font-body font-normal" data-id="element-101">
                USD
              </span>
            </p>
            <p className="mt-3 text-sm font-semibold text-burgundy-light uppercase tracking-wide" data-id="element-102">
              ¡Ahorre más del 68%!
            </p>
          </div>

          <Button href="https://www.ayudadigiguia.com/cart/47408569942246:1" className="w-full md:w-auto text-xl md:text-2xl py-6 px-12 shadow-warm mb-6" data-id="element-103">
            SÍ, QUIERO PROTEGER MI LEGADO AHORA
          </Button>

          <div className="flex flex-col items-center justify-center gap-2 text-sm text-charcoal-light" data-id="element-104">
            <p className="italic" data-id="element-105">*Acceso instantáneo en formato PDF.</p>
            <p className="flex items-center gap-1" data-id="element-106">
              <ShieldCheck className="w-4 h-4 text-green-600" data-id="element-107" /> Descarga segura
              y fácil de leer.
            </p>
          </div>
        </div>
      </div>
    </section>;
}